/*
 * @Author: edvardchen
 * @Date: 2017-09-26 18:07:49
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2019-12-17 15:11:42
 */

// @flow
import { url, isHippy } from '../../utility';
import { type Reducer } from '../types';

import { SET_DOM_TITLE, RESET_LOCATION, RESET_APN, SET_GRAY_CONFIG, SET_UA, VIDEO_LIST } from './actions';

export * from './actions';

const reducer: Reducer = (state, { type, payload }) => {
  switch (type) {
    case SET_DOM_TITLE:
      if (typeof payload === 'string') {
        return {
          ...state,
          title: payload,
        };
      }
      return state;
    case VIDEO_LIST:
      return {
        ...state,
        videoList: payload,
      };
    case RESET_LOCATION: {
      const location = url.parse(payload, true);

      // 无法通过 window.originalPostMessage 来判断是否 RN，
      // 因为 RN 的 postMessage 可能未注入，因此需要额外的 url 参数来区分
      const {
        query: { ch, pid, isFv },
      } = location;
      const isFastV = !!(pid === '17' || isFv);
      const isHp = isHippy();
      console.debug('RESET_LOCATION-isFastV', isFastV, payload, isHp);
      location.isFastV = isFastV;
      return {
        ...state,
        location,
        article: {
          ...state.article,
          preventDistrStatus: isFastV,
        },
        currentChannel: ch,
        inRN: isHp,
      };
    }
    case RESET_APN:
      return {
        ...state,
        apn: payload,
      };
    case SET_GRAY_CONFIG:
      return {
        ...state,
        grayConfig: payload || {},
      };
    case SET_UA:
      return {
        ...state,
        ua: payload || '',
      };
    default:
      return state;
  }
};

export default reducer;
